export default {
  namespace: 'ndanalytics',
  src: '//static.analytics.netdirector.auto/2.17.3/sp.js',
  trackers: [
    {
      name: 'nd-components',
      endPoint: 'analytics.netdirector.auto',
      settings: {
        post: true,
        forceSecureTracker: true,
        stateStorageStrategy: 'localStorage',
        platform: 'web',
        contexts: {
          webPage: true,
          performanceTiming: false,
          gaCookies: false,
          geoLocation: false,
        }
      }
    }
  ]
};
